import { CreateDisplayGroupRole } from '../note-array/hooks/__generated__/CreateDisplayGroupRole'
import { CreateMessageAppearanceV2 } from './hooks/__generated__/CreateMessageAppearanceV2'
import { UpdateBoard } from './hooks/__generated__/UpdateBoard'

type MutationData<T> = T | null | undefined

export const mutationData = async <T>(mutation: Promise<{ data?: T | null }>) => {
  try {
    return (await mutation).data ?? null
  } catch {
    return null
  }
}

const withApiError = (message: string, apiError?: string | null) => (apiError ? `${message}: ${apiError}` : message)

export const updateBoardFailure = (boardId: string, data: MutationData<UpdateBoard>) =>
  data?.updateBoard?.updated ? null : `Failed to update settings for board ${boardId}`

export const displayGroupRoleFailure = (email: string, data: MutationData<CreateDisplayGroupRole>) => {
  const result = data?.createDisplayGroupRoleV2
  const message = `Failed to add member ${email}`

  if (!result) {
    return message
  }

  return result.__typename === 'DisplayGroupRoleErrorV2' ? withApiError(message, result.error) : null
}

export const messageAppearanceFailure = (boardId: string, data: MutationData<CreateMessageAppearanceV2>) => {
  const result = data?.createMessageAppearance
  const message = `Failed to send first message to board ${boardId}`

  if (!result) {
    return message
  }

  return result.__typename === 'MessageAppearanceErrorV2' ? withApiError(message, result.error) : null
}

export const setupFailuresMessage = (failures: (string | null)[]) => {
  const messages = failures.filter((failure): failure is string => !!failure)

  return messages.length ? `Note Array created, but some setup steps failed: ${messages.join('; ')}` : null
}
